import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import singUpBannerImg from "../../styles/images/sing_up_bg.png";
import singUpBannerImg2 from "../../styles/images/sing_up_bg2.png";
import loginBannerImg from "../../styles/images/img_login_banner.png";
import loginBannerIco1 from "../../styles/images/ico_login_banner1.svg";
import loginBannerIco2 from "../../styles/images/ico_login_banner2.svg";
import loginBannerIco3 from "../../styles/images/ico_login_banner3.svg";
import loginBannerIco4 from "../../styles/images/ico_login_banner4.svg";
import loginBannerIco5 from "../../styles/images/ico_login_banner5.svg";
import { ButtonL, ImgWrap } from "../../styles/Common";
import { useDispatch, useSelector } from "react-redux";

const SingUpBanner = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const data = useSelector((state) => state.main.affiliateIconList);
  const [bannerImage, setBannerImage] = useState(singUpBannerImg2);

  useEffect(() => {
    const currentDate = new Date();
    const targetEndDate = new Date("2024-05-09"); // 4월 29일로부터 10일 이후
    if (currentDate > targetEndDate) {
      // 5월 9일 이후
      setBannerImage(singUpBannerImg2);
    } else {
      setBannerImage(singUpBannerImg);
    }
  }, []);

  return (
    <>
      {props.isLogin ? (
        <>
          <LoginBanner>
            <div>
              <h3>
                <span>다양한 제휴사에 있는</span>
                <br />내 포인트, 이제 여기서 관리하세요.
              </h3>
              <p>
                다양한 제휴사 포인트를 MU Point로
                <br />
                전환하여 한곳에서 모아 사용하세요.
              </p>
            </div>
            {data && data.count > 0 ? (
              <CustomImg>
                <BoxWrap>
                  <Box
                    className={
                      data.list[5] ? "box box1 " : "box box1 noneContent"
                    }
                    width="2.6"
                    radius="4"
                  >
                    <img
                      src={data.list[5] ? data.list[5].image : loginBannerIco5}
                      alt="affiliate icon img"
                    />
                  </Box>
                  <Box
                    className={
                      data.list[4] ? "box box2 " : "box box2 noneContent"
                    }
                    width="4.2"
                    radius="8"
                  >
                    <img
                      src={data.list[4] ? data.list[4].image : loginBannerIco3}
                      alt="affiliate icon img"
                    />
                  </Box>
                  <Box
                    className={
                      data.list[3] ? "box box3 " : "box box3 noneContent"
                    }
                    width="4.3"
                    radius="8"
                  >
                    <img
                      src={data.list[3] ? data.list[3].image : loginBannerIco2}
                      alt="affiliate icon img"
                    />
                  </Box>
                  <Box
                    className={
                      data.list[2] ? "box box4 " : "box box4 noneContent"
                    }
                    width="5.1"
                    radius="9"
                  >
                    <img
                      src={data.list[2] ? data.list[2].image : loginBannerIco4}
                      alt="affiliate icon img"
                    />
                  </Box>
                  <Box
                    className={
                      data.list[1] ? "box box5 " : "box box5 noneContent"
                    }
                    width="5.7"
                    radius="10"
                  >
                    <img
                      src={data.list[1] ? data.list[1].image : loginBannerIco1}
                      alt="affiliate icon img"
                    />
                  </Box>
                  <Box
                    className={
                      data.list[0] ? "box box6 " : "box box6 noneContent"
                    }
                    width="5.7"
                    radius="10"
                  >
                    <img
                      src={data.list[0] ? data.list[0].image : loginBannerIco4}
                      alt="affiliate icon img"
                    />
                  </Box>
                </BoxWrap>
              </CustomImg>
            ) : (
              <CustomImg>
                <BoxWrap>
                  <Box className="box box1 noneContent" width="2.6" radius="4">
                    <img src={loginBannerIco5} alt="affiliate icon img" />
                  </Box>
                  <Box className="box box2 noneContent" width="4.2" radius="8">
                    <img src={loginBannerIco3} alt="affiliate icon img" />
                  </Box>
                  <Box className="box box3 noneContent" width="4.3" radius="8">
                    <img src={loginBannerIco2} alt="affiliate icon img" />
                  </Box>
                  <Box className="box box4 noneContent" width="5.1" radius="9">
                    <img src={loginBannerIco4} alt="affiliate icon img" />
                  </Box>
                  <Box className="box box5 noneContent" width="5.7" radius="10">
                    <img src={loginBannerIco1} alt="affiliate icon img" />
                  </Box>
                  <Box className="box box6 noneContent" width="5.7" radius="10">
                    <img src={loginBannerIco4} alt="affiliate icon img" />
                  </Box>
                </BoxWrap>
              </CustomImg>
            )}
            <ImgWrap imgwidth="29.9" margintop="-6">
              <img src={loginBannerImg} alt="login banner" />
            </ImgWrap>
          </LoginBanner>
        </>
      ) : (
        <SingUpBannerWrap>
          <img src={bannerImage} alt="signUp banner" />
          <ButtonL
            onClick={
              props.isLogin
                ? () => {
                    return;
                  }
                : () => {
                    navigate("/sign-up");
                  }
            }
          >
            지금 가입하기
          </ButtonL>
        </SingUpBannerWrap>
      )}
    </>
  );
};

export default SingUpBanner;

const SingUpBannerWrap = styled.div`
  position: relative;
  width: 100%;
  background-color: ${({ theme }) => theme.color.purple_bg_light};
  img {
    width: 100%;
  }
  button {
    position: absolute;
    width: calc(100% - 3.2rem);
    bottom: 1.6rem;
    right: 0;
    left: 0;
    margin: auto;
  }
`;

const LoginBanner = styled.div`
  padding: 3rem 2.6rem 3rem 2.6rem;
  background-color: ${({ theme }) => theme.color.purple_bg_light};

  h3 {
    color: ${({ theme }) => theme.color.purple_dark};
    font-size: 2.2rem;
    font-weight: 400;
    line-height: 2.5rem;
    font-family: NanumSquareR;
    span {
      font-weight: 800;
      font-family: NanumSquareEB;
    }
  }
  p {
    margin-top: 2rem;
    color: #5540a5;

    font-family: NanumSquareR;
    font-size: 1.8rem;
    font-weight: 400;
    line-height: 2.1rem;
  }
`;
const CustomImg = styled.div`
  position: relative;
  /* margin-top: 6rem; */

  .box {
    filter: drop-shadow(0px 4px 4px rgba(62, 60, 114, 0.1));
    background-color: ${({ theme }) => theme.color.white};
    left: 0;
    right: 0;
    margin: auto;
  }
`;
const BoxWrap = styled.div`
  height: 23.5rem;
  width: 29.9rem;
  position: relative;
  left: 0;
  right: 0;
  margin: auto;
  /* background-color: azure; */

  .box1 {
    height: 2.1rem;
    bottom: 0.17rem;
    /* margin-left: calc(50% + 0.685rem); */
    z-index: 1;
    overflow: hidden;
    border-radius: 4px 4px 0 0;
    background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.9));
    &::before {
      position: absolute;
      width: 100%;
      height: 100%;
      content: "";
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0) 27.27%,
        rgba(0, 0, 0, 0.2) 100%
      );
      z-index: 7;
    }
    img {
      margin-top: 0.5rem;
    }
  }

  .box2 {
    bottom: 4.785rem;
    margin-right: 50%;
    z-index: 2;
  }
  .box3 {
    z-index: 3;
    bottom: 8rem;
    margin-right: calc(50% + 3rem);
  }
  .box4 {
    z-index: 4;
    bottom: 6.3rem;
    margin-left: calc(50% + 3rem);
  }
  .box5 {
    z-index: 5;
    bottom: 10.5rem;
    margin-left: calc(50% + 6rem);
  }
  .box6 {
    z-index: 6;
    bottom: 13.5rem;
    margin-right: calc(50% + 8rem);
  }
`;
const Box = styled.div`
  width: ${(props) => props.width}rem;
  height: ${(props) => props.width}rem;
  border-radius: ${(props) => props.radius}px;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 100%;
    /* max-width: 70%;
    max-height: 90%; */
    position: relative;
  }
  &.noneContent {
    img {
      width: 70%;
      max-width: 70%;
      max-height: 90%;
    }
  }
`;
